import React from 'react';
import {useCategory} from '@netx/core-category/hooks';
import {getCurrentPortalProp, isBrandPortal} from '@netx/core-cms-next/utils';
import {Breadcrumb} from '@netx/core-components/Breadcrumb';
import {
	AssetGalleryBreadcrumbsBase,
	type AssetGalleryBreadcrumbsBaseProps,
} from './AssetGalleryBreadcrumbsBase';
import {AssetGalleryTitle} from '../../locales';

export type AssetGalleryBreadcrumbsCategoryProps =
	AssetGalleryBreadcrumbsBaseProps & {
		id: number;
		searchWithin?: string | number;
	};

export const AssetGalleryBreadcrumbsCategoryPrimitive = ({
	id,
	isAI,
	searchWithin,
	...props
}: AssetGalleryBreadcrumbsCategoryProps) => {
	const {category, loading} = useCategory({id});

	const getCrumbs = () => {
		const topLevel = (isBrandPortal() && getCurrentPortalProp('category')) || 0;

		if (topLevel === id) return null;

		if (loading) return <Breadcrumb key={id} loading />;

		if (!category) return <Breadcrumb key={id} label="(unknown)" />;

		let ancestors = [...category.ancestors].reverse();
		let categoryNames = category.path.split(' >> ');
		// we want to ignore the "top level" category and any ancestors of it
		const indexOfTopLevel = ancestors.indexOf(topLevel);
		if (indexOfTopLevel > -1) {
			ancestors = ancestors.slice(indexOfTopLevel);
			categoryNames = categoryNames.slice(indexOfTopLevel);
		}

		const totalCategegories = categoryNames.length;

		const crumbs = categoryNames.map((label, index) => (
			<Breadcrumb
				key={`${id}-${ancestors[index + 1]}`}
				label={label}
				url={
					totalCategegories - 1 === index
						? searchWithin
							? `#category/${id}`
							: undefined
						: `#category/${ancestors[index + 1]}`
				}
			/>
		));

		// if (searchWithin) {
		// 	crumbs.push(
		// 		<Breadcrumb
		// 			key={`${id}-searchWithin`}
		// 			label={searchWithin.toString()}
		// 		/>,
		// 	);
		// }

		if (isAI) {
			crumbs.push(<Breadcrumb key={`${id}-ai`} label={AssetGalleryTitle.AI} />);
		}

		return crumbs;
	};

	return (
		<AssetGalleryBreadcrumbsBase itemsBeforeCollapse={2} {...props}>
			{getCrumbs()}
		</AssetGalleryBreadcrumbsBase>
	);
};

export const AssetGalleryBreadcrumbsCategory =
	AssetGalleryBreadcrumbsCategoryPrimitive;

export default AssetGalleryBreadcrumbsCategory;
